<template>
  <div class="wrapped-video">
    <video
      ref="videoElement"
      class="wrapped-video__main"
      v-if="isPwaModeActive && sources.length > 0 && isVisible"
      controls
      playsinline
      @invalid="onError"
      @error="onError"
      @loadstart="onLog"
      @load="onLog"
      @loadeddata="onLog"
      @play="onPlay"
    >
      <source
        v-for="source in sources"
        :key="source.type"
        :src="source.src"
        :type="source.type"
      />
    </video>
    <iframe
      v-else-if="!isPwaModeActive"
      class="embed-responsive-item vimeo wrapped-video__main"
      :src="`https://player.vimeo.com/video/${vimeoId}`"
      webkitallowfullscreen
      mozallowfullscreen
      allowfullscreen
    />
    <button
      v-else-if="isPwaModeActive && !isPlaying && poster"
      @click="play"
      class="wrapped-video__play-button"
      :style="`background-image: url('${poster}')`"
    />
  </div>
</template>

<script>
import { createVimeoMetadataUrl } from "@/services/urlBuilder.js";

function resetState(component) {
  return {
    sources: [],
    vimeoId: "",
    videoElement: null,
    isPlaying: false,
    isVisible: component.poster === undefined
  };
}

export default {
  name: "WrappedVideo",
  props: {
    name: String,
    poster: String
  },
  data() {
    return resetState(this);
  },
  watch: {
    "$store.state.language": function() {
      const newState = resetState(this);
      const keys = Object.keys(newState);
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        this[key] = newState[key];
      }
      this.refresh();
    }
  },
  computed: {
    isPwaModeActive() {
      return this.$store.state.isPwaModeActive;
    }
  },
  mounted() {
    this.refresh();
    document.addEventListener("videodownloaded", this.onDbUpdate);
  },
  beforeUnmount() {
    document.removeEventListener("videodownloaded", this.onDbUpdate);
  },
  methods: {
    onError(e) {
      if (e.message) {
        alert(e.message);
      } else {
        console.error(e);
        alert(this.$i18n.t("error_video_generic"));
      }
    },
    onLog(e) {
      /*
      if (e.type === "loadstart") {
      } else if (e.type === "loadeddata") {
      }
      */
      //console.log(e);
    },
    play() {
      this.isVisible = true;
      setTimeout(() => {
        this.$refs.videoElement && this.$refs.videoElement.play();
      }, 200);
    },
    onPlay() {
      this.isPlaying = true;
    },
    refresh() {
      if (!this.isVisible) {
        this.setVideo();
        return;
      }
      this.isVisible = false;
      this.setVideo();
      setTimeout(() => {
        this.isVisible = true;
      }, 1000);
    },
    setVideo() {
      const { videos, language } = this.$store.state;
      const video = videos[language][this.name];
      this.sources = [
        {
          src: createVimeoMetadataUrl(video),
          type: "video/mp4"
        }
      ];
      this.vimeoId = video.vimeoId;
    },
    onDbUpdate(e) {
      if (e.detail.vimeoId === this.vimeoId) {
        this.refresh();
      }
    }
  }
};
</script>

<style>
.wrapped-video {
  position: relative;
  width: 100%;
  border: 0;
}
.wrapped-video__main {
  height: 100%;
  width: 100%;
  object-fit: fill;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  border: 0;
}
.wrapped-video__main:active,
.wrapped-video__main:focus {
  border: 0;
}
.wrapped-video__play-button {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  border: 0;
}
</style>
